import React, { createContext, useContext, useState, useEffect } from 'react';
import API, { setBranch } from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  const login = async (username, password) => {
    const { data } = await API.post('/auth/login', { username, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    /* Hər yeni sessiya bütün kampuslarla başlayır. Əvvəl kampus seçimi
       localStorage-də qalırdı: admin bir dəfə Xankəndini seçəndən sonra
       növbəti girişlərdə sistem boş görünürdü və səbəbi bilinmirdi. */
    setBranch('all');
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setBranch('all');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
